import { RemoteHandleSummaryReportByInternshipLocation } from 'data/usecases';
import { HandleSummaryReportByInternshipLocation } from 'domain/usecases';
import { makeApiUrlSummaryReportByInternshipLocation } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeHandleSummaryReportByInternshipLocation =
  (): HandleSummaryReportByInternshipLocation =>
    new RemoteHandleSummaryReportByInternshipLocation(
      makeApiUrlSummaryReportByInternshipLocation(),
      makeAxiosHttpClient(),
    );
